import React from 'react';

import DislikeButton from 'application/components/DislikeButton';
import { useWebPlayerActionsContext, useWebPlayerContext } from 'application/providers/WebPlayerProvider';
import { useAccountIsAuthorized } from 'application/hooks';
import { DEFAULT_ERROR_MESSAGE } from '@shared/config';

import { toast } from '@shared/ui';

import { PERMISSION_REGEXP } from '../consts';
import { TEXTS } from '../texts';
import styles from '../index.module.scss';

interface IWebPlayerPureDislikeButtonProps {
  id?: string | number;
  isDisabled?: boolean;
  streamId: string;
  onDislike?: () => void;
  hint?: string;
}

const WebPlayerPureDislikeButton: React.FC<IWebPlayerPureDislikeButtonProps> = ({
  hint,
  onDislike,
  streamId,
  isDisabled,
  id,
}) => {
  const { disliked, mediaFile, actions } = useWebPlayerContext();
  const { onUnAuthorizedClick, setDisliked } = useWebPlayerActionsContext();

  const dislikedMapKey = `${id}/${streamId}`;

  const isAuthorized = useAccountIsAuthorized();

  const onDislikeClick = () => {
    onDislike?.();

    if (!onDislike && mediaFile?.id === id) {
      actions.nextTrack();
    }

    toast.info(TEXTS.TRACK_REMOVED);
  };

  const onSetDislike = (value: boolean) => {
    setDisliked({
      ...disliked,
      [dislikedMapKey]: value,
    });
  };

  const dislikeErrorHandler = (error: unknown) => {
    const dislikeError = error as Error;
    const isPermissionMessage = dislikeError.message && PERMISSION_REGEXP.test(dislikeError.message);
    const message = isPermissionMessage ? TEXTS.NO_DISLIKE_PERMISSION : DEFAULT_ERROR_MESSAGE;

    toast.error(message);
  };

  const onUnAuthorized = () => {
    onUnAuthorizedClick(TEXTS.LOGIN_REQUIRED_DISLIKE_CONTENT);
  };

  return (
    <DislikeButton
      id={id}
      streamId={streamId}
      onDislike={onDislikeClick}
      isDisabled={isDisabled || !isAuthorized}
      isDisliked={disliked[dislikedMapKey]}
      hint={hint}
      isAuthorized={isAuthorized}
      onUnAuthorizedClick={onUnAuthorized}
      errorHandler={dislikeErrorHandler}
      buttonClassName={styles.autoEvents}
      setIsDisliked={onSetDislike}
    />
  );
};

export default WebPlayerPureDislikeButton;
